import store from "@/store/index";

export default (to, from, next) => {
  const isWalkthroughVideo = to.matched.some(
    record => !!record.meta.walkthroughVideo
  );
  if (isWalkthroughVideo) {
    if (!isWalkthroughVideoRequired()) {
      return next({ name: "my-plane" });
    }
    next();

    return false;
  }

  if (isWalkthroughVideoRequired()) {
    next({ name: "walkthrough-video" });
    return false;
  }

  next();
};

function getCustomer() {
  return store.getters["customers/customer"];
}

function hasCustomer() {
  return !!getCustomer();
}

function isWalkthroughVideoRequired() {
  return hasCustomer() && !getCustomer().firstClubVideoCompleted;
}
